export class TextConfiguration {
  textName: string;
  textContent: string;
}
